module.exports = __webpack_public_path__ + "static/media/gb.5662d304.svg";